import {
  RMR_LLM_FALLBACK,
  RMR_LLM_GEMINI,
  RMR_LLM_OPENAI,
  RMR_LLM_PERPLEXITY,
} from "@/styles/tokens";

export const LLM_META = {
  perplexity: {
    hex: RMR_LLM_PERPLEXITY,
    label: "Perplexity",
    shortLabel: "P",
  },
  gemini: {
    hex: RMR_LLM_GEMINI,
    label: "Gemini",
    shortLabel: "G",
  },
  openai: {
    hex: RMR_LLM_OPENAI,
    label: "ChatGPT",
    shortLabel: "O",
  },
};

export const getLlmMeta = (provider) => {
  return LLM_META[provider] || null;
};

export const getLlmDisplayName = (provider) => {
  const meta = getLlmMeta(provider);
  return meta ? meta.label : provider;
};

export const getLlmHex = (provider) => {
  const meta = getLlmMeta(provider);
  return meta ? meta.hex : RMR_LLM_FALLBACK;
};

export const getLlmShortLabel = (provider) => {
  const meta = getLlmMeta(provider);
  return meta ? meta.shortLabel : "?";
};

export const normalizeLlmProvider = (provider) => {
  if (!provider) {
    return null;
  }

  const normalized = String(provider).toLowerCase();
  if (normalized.includes("gemini")) {
    return "gemini";
  }
  if (normalized.includes("perplexity")) {
    return "perplexity";
  }
  if (
    normalized.includes("openai") ||
    normalized.includes("chatgpt") ||
    normalized.includes("gpt")
  ) {
    return "openai";
  }

  return null;
};
